import React, { useEffect, useState } from "react";
import LoaderOverlay from "../components/checkout/LoaderOverlay";

export default function Success() {
  const [isValid, setIsValid] = useState(true);
  const [details, setDetails] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pi = params.get("payment_intent");

    // ✅ Only allow access if PaymentIntent ID or order exists
    if (pi) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (!isValid) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 font-inter">
        <div className="bg-white p-10 rounded-2xl shadow-md max-w-md text-center">
          <h1 className="text-2xl font-semibold text-gray-800 mb-3">
            Invalid Access
          </h1>
          <p className="text-gray-600 mb-5">
            This page is only accessible after completing a valid order.
          </p>
          <a
            href="https://www.wurq.io/"
            className="inline-block bg-black text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-900 transition"
          >
            Go to Home
          </a>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return <LoaderOverlay show />;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 font-inter px-4">
      <div className="bg-white p-10 rounded-2xl shadow-md max-w-md w-full text-center">
        <h1 className="text-2xl font-semibold text-gray-800 mb-3">
          Thank you for your WurQ Beta Order!
        </h1>
        <p className="text-gray-600 mb-5 leading-relaxed">
          You will be charged for your subscription only when the product is
          delivered.
        </p>

        {/* {details?.order && (
          <p className="text-sm text-gray-500 mb-6">
            <strong>Order Number:</strong> {details.order}
            {details.total && (
              <>
                {" "}
                <br />
                <strong>Total:</strong> ${details.total}
              </>
            )}
          </p>
        )} */}

        <div className="flex flex-col sm:flex-row justify-center gap-3">
          {/* <a
            href="https://www.wurq.io/"
            className="inline-block bg-gray-200 text-gray-800 px-6 py-3 rounded-lg font-medium hover:bg-gray-300 transition"
          >
            Go to Home
          </a> */}

          <a
            href={process.env.REACT_APP_SUB_URL}
            className="inline-block bg-[#da291c] text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-900 transition"
          >
            Manage Subscription
          </a>
        </div>
      </div>
    </div>
  );
}
